import React, { useEffect, useState } from "react";
import NavBar from "../NavBar";
import { TeamsData as IncomingData } from "./CRMData/CRMTeamsData";
// import { CardData } from "../CRM/CRMData/CRMCardData";
import CardRender from "../DashboardCardRender";
import TeamsIDCard from "./IDcard/teamsIDCard";
import TeamsDetailsCard from "../CRM/IDcard/teamsDetailsCard";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DotsComponent from "../DotsComponent";
import WideCard from "../WideCard";
import { CRMWideCardData } from "../WideCardData";


const CRMTeams = () => {
  const [count, setCount] = useState([]);
  const [filtr, setFiltr] = useState("");
  const [type, setType] = useState('');
  const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  
  useEffect(() => {
    if (type === 1) {
      setCount(
        IncomingData.filter(
          (x) => x.Team_status === "inactive" || x.td4 === "Overdue"
        )
      );
    } else if (type === 0) {
      setCount(IncomingData.filter((x) => x.Team_status === "active"));
    } else {
      setCount("");
    }
    setFiltr("");
  }, [type]);

  const handleFilter = (e) => {
    setFiltr(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.Amount < 5000
      } 
      else if (e.target.value === '2') {
        return x.Amount > 50000
      }
      else if (e.target.value === '3') {
        return x.Amount > 100000
      }
    }));
    // setType('')
  };
  return (
    <>
      <NavBar />
      
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">
            Customer Relationship Management{" "}
          </span>
          <span className="color"> &#62; </span>
          <span className="color"> Teams</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Teams</h1>
        <div style={{ display: "flex", gap: "6px" }}>
          <div className="create-team"
            style={{
              
            }}
          >
          <span>
          <AddCircleOutlineIcon />
          </span>
           <div > Create Team</div>
          </div>
          <div id="Right-content-Down-Filters">
            {/* <div
              style={{
                "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
                height: "80%",
              }}
            ></div> */}
            <MoreVertIcon />
          </div>
        </div>
      </div>

      <div id="click-data" style={{ marginLeft: "1rem" }}>
      <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
            Active
          </p>
          <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
            Inactive
          </p>
      </div>
      <div id="OMS-main-content">
        {/* list and teams details card */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "65%",
            gap: "20px",
          }}
        >
          <div
            className="order-list-box"
            style={{ width: "100%", height: "auto", marginTop:"0", marginBottom:'0' }}
          >
            <div style={{ diplay: "flex" }}>
              <div className="order-list-input-box" style={{ width: "auto" }}>
                <div className="order-list-input-left">
                  <input
                    type="text"
                    placeholder="Search for employee ID, employee name"
                    onChange={(val) => {
                      setCount(
                        IncomingData.filter((x) =>
                          x.Employee_ID.match(val.target.value) || x.Employee_Name.match(val.target.value)
                        )
                      );
                      setFiltr("");
                      setType('');
                    }}
                  />
                  {/* <img src={searchWhiteIcon} alt="" width="" /> */}
                </div>
                <div
                  className="order-list-input-right"
                  style={{ width: "none" }}
                >
                  <select
                    name=""
                    id=""
                    className="order-list-input-right-filters"
                    value={filtr}
                    onChange={handleFilter}
                  >
                    <option value="" selected>
                      by amount
                    </option>
                    <option value="1">&lt;5000</option>
        <option value="2">&gt;50000</option>
        <option value="3">&gt;100000</option>
                  </select>
                </div>
              </div>
              <table  className="th-light" style={{ width: "100%" }}>
                <tr>
                  <th>Employee ID</th>
                  <th>Employee Name</th>
                  <th>Team Name</th>
                  <th>Created on</th>
                  <th>Department </th>
                  <th>Amount</th>
                  <th>Team Status</th>
                  <th>Last Order</th>
                </tr>
                {count.length > 0
                  ? count.map((val) => {
                      return (
                        <tr>
                          <td style={{textDecoration:"underline"}}>{val.Employee_ID}</td>
                          <td>{val.Employee_Name}</td>
                          <td>{val.Team_name}</td>
                          <td>{val.Credit_on}</td>
                          <td>{val.Department}</td>
                          <td>{val.Amount}</td>
                          <td className="col-status"
                      id={
                        val.Team_status === "active"
                          ? "col-green"
                          : val.Team_status === "inactive"
                          ? "col-red"
                          : ""
                      }
                      >{val.Team_status}</td>
                          <td>{val.Last_order}</td>
                        </tr>
                      );
                    })
                  : IncomingData.map((val) => {
                      return (
                        <tr>
                          <td style={{textDecoration:"underline"}}>{val.Employee_ID}</td>
                          <td>{val.Employee_Name}</td>
                          <td>{val.Team_name}</td>
                          <td>{val.Credit_on}</td>
                          <td>{val.Department}</td>
                          <td>{val.Amount}</td>
                          <td className="col-status"
                      id={
                        val.Team_status === "active"
                          ? "col-green"
                          : val.Team_status === "inactive"
                          ? "col-red"
                          : ""
                      }
                      >{val.Team_status}</td>
                          <td>{val.Last_order}</td>
                        </tr>
                      );
                    })}
              </table>
            </div>
          </div>
          <TeamsDetailsCard />
        </div>
        {/* card data */}

        <div>
          <div style={{ display: "flex", gap: "20px",width:"30rem" }}>
            <CardRender comp={CardData} />
          </div>

          <WideCard data={CRMTeamsWideCardData} />
          <div>
            <TeamsIDCard />
          </div>
        </div>
      </div>
    </>
  );
};
const CRMTeamsWideCardData = {
  card1up1: "200",
  card1up3: 'increased by 3% since last year',
  card1dnP: "TARGET FOR THIS YEAR",
}
const  CardData = [ {
  card1up1: "100",
  card1up2: "teams",
  card1up3: "increased by 5% since last month",
  card1dnP: "TOTAL TEAMS",
},
{
  card1up1: "30",
  card1up2: "teams active",
  card1up3: "increased by 10% since last month",
  card1dnP: "ACTIVE TEAMS",
},
];

export default CRMTeams;


